import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LoaderComponent } from '@modules/shared/components/loader/loader.component';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private dialog = inject(MatDialog);

  private dialogRefs: MatDialogRef<LoaderComponent>[] = [];

  public start(text?: string): MatDialogRef<LoaderComponent> {
    const dialogRef = this.dialog.open(LoaderComponent, {
      data: text ? text : null,
      hasBackdrop: false,
    });

    this.dialogRefs.push(dialogRef);

    return dialogRef;
  }

  public stop(): void {
    this.dialogRefs.forEach(ref => ref.close());
    this.dialogRefs = [];
  }
}
